import { erc20Abi } from 'viem';
import { useReadContracts } from 'wagmi';

import { ChainContracts } from '@/app/shared/constants/web3/chainContracts';

interface UseVaultTokenSymbolsArgs {
  contracts?: ChainContracts;
  trancheAddress?: `0x${string}`;
}

export const useVaultTokenSymbols = ({ contracts, trancheAddress }: UseVaultTokenSymbolsArgs) => {
  const { data: symbolResults } = useReadContracts({
    contracts:
      contracts && trancheAddress
        ? [
            { address: contracts.ASSET, abi: erc20Abi, functionName: 'symbol' },
            { address: contracts.MZUSD, abi: erc20Abi, functionName: 'symbol' },
            { address: trancheAddress, abi: erc20Abi, functionName: 'symbol' },
          ]
        : [],
    query: {
      enabled: !!contracts && !!trancheAddress,
    },
  });

  const usdcSymbol = symbolResults?.[0]?.status === 'success' ? symbolResults[0].result : undefined;
  const mzusdSymbol = symbolResults?.[1]?.status === 'success' ? symbolResults[1].result : undefined;
  const trancheSymbol = symbolResults?.[2]?.status === 'success' ? symbolResults[2].result : undefined;

  return { usdcSymbol, mzusdSymbol, trancheSymbol };
};
